import { axiosBaseQuery } from 'react-common'
import { lmsKMRequest } from 'react-common'
import { createApi } from '@reduxjs/toolkit/query/react'

type ObjectiveKnowledgeModel = {
  objectiveId: string
  knowledgeModelId: string
}

export const objectiveKnowledgeModelsApi = createApi({
  reducerPath: 'objectiveKnowledgeModelsApi',
  baseQuery: axiosBaseQuery(lmsKMRequest),
  endpoints: (builder) => ({
    fetchObjectiveKnowledgeModel: builder.query<ObjectiveKnowledgeModel, string>({
      query: (objectiveWorkflowAggregateId) => ({
        url: `users/me/objective-workflow-aggregates/${objectiveWorkflowAggregateId}/knowledge-model`,
        method: 'get',
      }),
    }),
  }),
})

export const { useFetchObjectiveKnowledgeModelQuery } = objectiveKnowledgeModelsApi
